<template>
  <div class="mb-test-with-points">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
      }"
    />
    <div class="main-box">
      <p :style="startGameConfig.labelStyle" v-if="startGameConfig.label && currentImg != -1">
        Pytanie {{ currentImg + 1 }} z {{ items.length }}
      </p>
      <div :key="'test-with-points-' + index" v-for="(it, index) in items" style="display: flex">
        <div :style="startGameConfig.questionBoxStyle" style="display: flex">
          <div
            class="audio"
            v-if="it.audioSrc && currentImg == index"
            style="width: 60px; height: 60px; margin: 10px 0px; pointer-events: auto; display: inline-block"
            :style="it.audioCss"
          >
            <!-- <div class="audio-icon"><span>mp3</span></div> -->
            <div
              style="width: 100%; height: 100%; position: relative; cursor: pointer"
              v-if="it.audio"
              @mouseenter="hoverOnIcon = true"
              @mouseleave="hoverOnIcon = false"
            >
              <img
                :src="aduioOn"
                style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
                v-if="!audioStatus && !hoverOnIcon"
                @click="startPlayItemAudio(it.audio)"
              />
              <img
                :src="aduioOnHover"
                style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
                v-if="!audioStatus && hoverOnIcon"
                @click="startPlayItemAudio(it.audio)"
              />
              <img
                :src="aduioOff"
                style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
                v-if="audioStatus && !hoverOnIcon"
                @click="stopPlayItemAudio(it.audio)"
              />
              <img
                :src="aduioOffHover"
                style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
                v-if="audioStatus && hoverOnIcon"
                @click="stopPlayItemAudio(it.audio)"
              />
            </div>
          </div>
          <p
            :style="{
              ...{
                padding: '0',
                width: it.width + 'px',
                height: it.height + 'px',
                fontSize: it.fontSize,
                textAlign: it.textAlign,
                margin: it.margin,
                color: it.color,
                zIndex: 2,
              },
              ...it.cssStyle,
            }"
            v-if="currentImg == index && it.text"
            v-html="changeAllPaths(it.text)"
          ></p>
          <img
            :src="giveMeImagePlease(it.src)"
            :style="[{ width: it.width + 'px' }, it.imgStyle]"
            v-if="currentImg == index && it.src"
          />
        </div>
        <div class="test-with-points-answers" v-if="currentImg == index && startGameConfig.answers">
          <div
            v-for="(it2, index2) in it.answers"
            :key="index + '-test-with-points-answer-' + index2"
            :style="{ ...startGameConfig.answers[index2], ...it2.cssStyle }"
          >
            <mb-audio
              v-if="it2.audioSrc"
              :item-audio="{ audioSrc: it2.audioSrc, position: 'relative', audioCss: it2.audioCss }"
            >
            </mb-audio>
            <p :style="it2.cssStyle" v-html="giveMeAnswerPlease(it2, index2)" @click="check(it2.correct || false)"></p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="test-with-points-input"
      :style="startGameConfig.inputBoxStyle"
      v-if="currentImg != -1 && !startGameConfig.testBool && !startGameConfig.answers"
    >
      <input
        :maxlength="startGameConfig.maxLength"
        :style="[startGameConfig.inputStyle, setInputStyle()]"
        v-model="currentValue"
        :disabled="answerStatus != ''"
        @input.self="isItGoodOrNo()"
      />
    </div>
    <div
      class="test-with-points-bool-test"
      :style="startGameConfig.testBoolStyle"
      v-if="currentImg != -1 && startGameConfig.testBool"
    >
      <img @click="isItTrueOrFalse(true)" :src="giveMeImagePlease(startGameConfig.testBool.positive)" />
      <img @click="isItTrueOrFalse(false)" :src="giveMeImagePlease(startGameConfig.testBool.negative)" />
    </div>
    <div class="mb-test-with-points-points-box" v-if="startGameConfig.icons" :style="startGameConfig.pointsBoxStyle">
      <div class="point-box-left" :style="startGameConfig.pointsBoxLeftStyle">
        <div class="top">
          <img :src="giveMeImagePlease(startGameConfig.icons.positive)" />
        </div>
        <div class="bot">
          <p :style="{ color: startGameConfig.pointsColor, fontSize: startGameConfig.pointsFontSize }">
            {{ points.positive }}
          </p>
        </div>
      </div>
      <div class="point-box-right" :style="startGameConfig.pointsBoxRightStyle">
        <div class="top">
          <img :src="giveMeImagePlease(startGameConfig.icons.negative)" />
        </div>
        <div class="bot">
          <p :style="{ color: startGameConfig.pointsColor, fontSize: startGameConfig.pointsFontSize }">
            {{ points.negative }}
          </p>
        </div>
      </div>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-test-with-points',
  components: { mbAudioInGame, MbAudio },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      currentImg: 0,
      points: {
        positive: 0,
        negative: 0,
      },
      answerStatus: '',
      currentValue: '',
      audio: null,
      status: false,
      canIPlay: true,
      items: [],
      curtain: [],
      openItem: [],
      fieldImg: [],
      currentField: 0,
      canICheck: true,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
      aduioOn: null,
      aduioOnHover: null,
      aduioOff: null,
      aduioOffHover: null,
      audioStatus: false,
      hoverOnIcon: false,
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    setInputStyle() {
      let style = {};
      if (this.startGameConfig.restTime) {
        if (this.answerStatus == 'correct') {
          style.border = '5px solid green';
        } else if (this.answerStatus == 'incorrect') {
          style.border = '5px solid red';
        } else {
          style.border = '5px solid transparent';
        }
      }
      return style;
    },
    startPlayItemAudio(audio) {
      if (audio) {
        audio.play();
      } else {
        this.stopPlay();
      }
    },
    stopPlayItemAudio(audio) {
      audio.stop();
    },
    check(state) {
      if (this.canICheck) {
        if (this.currentImg != -1) {
          this.canICheck = false;
          if (this.items[this.currentImg].audio) {
            this.stopPlayItemAudio(this.items[this.currentImg].audio);
          }
          if (this.startGameConfig.checkBox) {
            if (event.target.localName == 'img') {
              event.target.parentNode.firstElementChild.src = this.giveMeImagePlease(
                this.startGameConfig.checkBox.src2
              );
            } else {
              event.target.firstElementChild.src = this.giveMeImagePlease(this.startGameConfig.checkBox.src2);
            }
          }
          setTimeout(() => {
            console.log(state);
            if (state) {
              console.log('yeah');
              this.points.positive++;
              this.checkSound(true);
            } else {
              this.points.negative++;
              this.checkSound(false);
            }
            let time = this.startGameConfig.restTime ? this.startGameConfig.restTime : 0;
            setTimeout(() => {
              console.log(time);
              if (this.currentImg + 1 != this.items.length) {
                this.currentImg++;
              } else {
                this.currentImg = -1;
                console.log('endOfGame');
                this.$store.dispatch('checkGame');
              }
            }, time);

            this.canICheck = true;
          }, 500);
        }
      }
    },
    giveMeAnswerPlease(answer, index) {
      let a = '';
      if (this.startGameConfig.checkBox) {
        a +=
          '<img style="' +
          this.getStyle(this.startGameConfig.checkBox.cssStyle) +
          '" src="' +
          this.giveMeImagePlease(this.startGameConfig.checkBox.src) +
          '" />';
      }
      if (this.startGameConfig.answers[index].staticText) {
        a +=
          '<p style="' +
          this.getStyle(this.startGameConfig.answers[index].staticText.cssStyle) +
          '">' +
          this.startGameConfig.answers[index].staticText.text +
          '</p>';
      }
      a += this.changeAllPaths(answer.text);
      return a;
    },
    changeAllPaths(text) {
      let src = '';
      let paths = text.match(/src=".*?"/g);
      if (paths !== null) {
        for (let path of paths) {
          src = path.substring(5, path.length - 1);
          text = text.replace(src, this.giveMeImagePlease(src));
        }
      }
      return text;
    },
    getStyle(item) {
      let style = '';
      for (let key in item) {
        if (item.hasOwnProperty(key)) {
          style += `${key}: ${item[key]};`;
        }
      }
      return style;
    },
    isItTrueOrFalse(state) {
      if (this.canICheck) {
        if (this.currentImg != -1) {
          this.canICheck = false;
          if (this.items[this.currentImg].audio) {
            this.stopPlayItemAudio(this.items[this.currentImg].audio);
          }
          setTimeout(() => {
            console.log(this.items[this.currentImg].correct + ' : ' + state);
            if (this.items[this.currentImg].correct == state) {
              console.log('yeah');
              this.points.positive++;
              this.checkSound(true);
            } else {
              this.points.negative++;
              this.checkSound(false);
            }
            if (this.currentImg + 1 != this.items.length) {
              this.currentImg++;
            } else {
              this.currentImg = -1;
              console.log('endOfGame');
              this.$store.dispatch('checkGame');
            }
            this.canICheck = true;
          }, 500);
        }
      }
    },
    isItGoodOrNo() {
      if (this.canICheck) {
        if (this.currentValue.length > 0) {
          let val = this.currentValue;
          // this.canICheck = false;
          if (this.currentImg != -1) {
            console.log(this.items[this.currentImg].correct.length + ' : ' + val.length);
            if (this.items[this.currentImg].correct.length == val.length) {
              this.canICheck = false;
              if (this.items[this.currentImg].audio) {
                this.stopPlayItemAudio(this.items[this.currentImg].audio);
              }
              setTimeout(() => {
                console.log(this.items[this.currentImg].correct);
                console.log(this.currentValue);
                if (this.items[this.currentImg].correct == val) {
                  console.log('yeah');
                  this.answerStatus = 'correct';
                  this.points.positive++;
                  this.checkSound(true);
                } else {
                  this.points.negative++;
                  this.answerStatus = 'incorrect';
                  this.checkSound(false);
                }
                let time = this.startGameConfig.restTime ? this.startGameConfig.restTime : 0;
                setTimeout(() => {
                  this.answerStatus = '';
                  console.log(time);
                  if (this.currentImg + 1 != this.items.length) {
                    this.currentValue = '';
                    this.currentImg++;
                  } else {
                    this.currentValue = '';
                    this.currentImg = -1;
                    console.log('endOfGame');
                    this.$store.dispatch('checkGame');
                  }
                }, time);
                this.canICheck = true;
              }, 500);
            }
          }
        }
      }
    },
    checkSound(status) {
      if (status) {
        if (this.audioPositive) {
          if (this.canIPlayASong) {
            this.audioPositive.play();
          } else {
            this.audioPositive.stop();
            if (this.audioNegative) {
              this.audioNegative.stop();
            }
            this.audioPositive.play();
          }
        }
      } else {
        if (this.audioNegative) {
          if (this.canIPlayASong) {
            this.audioNegative.play();
          } else {
            this.audioNegative.stop();
            if (this.audioPositive) {
              this.audioPositive.stop();
            }
            this.audioNegative.play();
          }
        }
      }
    },
    checkGameAction() {
      if (this.startGameConfig.pass) {
        if (this.points.positive > this.startGameConfig.pass) {
          return true;
        }
      } else {
        if (this.points.positive > 5) {
          return true;
        } else return false;
      }
    },
    init() {
      let item = this.startGameConfig.questions;
      if (this.startGameConfig.audio.positive) {
        this.audioPositive = new Howl({
          src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
      if (this.startGameConfig.audio.negative) {
        this.audioNegative = new Howl({
          src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
      this.shuffle(item);
      let pick;
      if (this.startGameConfig.pick) {
        pick = this.startGameConfig.pick;
      } else pick = item.length;
      for (let i = 0; i < pick; i++) {
        this.items.push(item[i]);
        if (this.items[i].answers) {
          this.shuffle(this.items[i].answers);
        }
      }
      this.setItemsAudio();
    },
    setItemsAudio() {
      try {
        this.aduioOn = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON;
        this.aduioOnHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON_HOVER;
        this.aduioOff = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF;
        this.aduioOffHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF_HOVER;
      } catch {
        console.log(
          '%cAudioIcon MbTestWithPoints - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      this.items.forEach((it) => {
        if (it.audioSrc) {
          it.audio = new Howl({
            src: this.giveMeImagePlease(it.audioSrc),
            autoplay: false,
            loop: false,
            volume: 1,
            onend: () => {
              this.audioStatus = false;
            },
            onstop: () => {
              this.audioStatus = false;
            },
            onplay: () => {
              this.audioStatus = true;
            },
          });
        }
      });
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onplay: () => {
          this.canIPlayASong = false;
        },
      });
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.answerStatus = '';
      this.currentValue = '';
      this.currentImg = 0;
      this.points.positive = 0;
      this.points.negative = 0;
      this.audio = null;
      this.status = false;
      this.canIPlay = true;
      this.items = [];
      this.curtain = [];
      this.openItem = [];
      this.init();
      this.canICheck = true;
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
  },
  destroyed() {},
  computed: {},
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-test-with-points
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .test-with-points-answers
    position: absolute
    width: 100%
    top: 0%
    left: 0%
    z-index: 3
    p
      position: absolute
  .test-with-points-bool-test
    position: absolute
    width: 50%
    bottom: 0%
    z-index: 2
    height: 80px
    display: flex
    justify-content: space-between
    align-items: center
    img
      height: 100%
      cursor: pointer
  .test-with-points-input
    position: fixed
    z-index: 3
    bottom: 30px
    input
      width: 200px
      height: 120px
      text-align: center
      font-size: 65px
      font-family: $gameFontFamily
  .main-box
    width: 100%
    height: 100%
    position: absolute
    top: 0
    // background: red
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    // flex-basis: 30%
    flex-wrap: wrap
  .mb-test-with-points-points-box
    position: fixed
    bottom: 0
    left: 100px
    width: 180px
    height: 180px
    // background: red
    .point-box-left, .point-box-right
      width: 100%
      height: 50%
      display: inline-block
      position: absolute
      // background: blue
      .top, .bot
        width: 50%
        height: 100%
        position: absolute
        display: flex
        justify-content: center
        align-items: center
        // background: green
      .bot
        p
          color: white
          font-size: 65px
          font-weight: bold
          margin: 0
          font-family: $gameFontFamily
      .bot
        right: 0
      .top
        left: 0
    .point-box-left
      top: 0
    .point-box-right
      bottom: 0
  .memory-box
    .mb-memory-field
      display: inline-block
      margin: 5px
      cursor: pointer
      position: relative
      .memory-curtain
        position: absolute
        top: 0

.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
